<input
    type="text"
    class="form-control"
    [style.font-style]="isIdpValue && !hasEdited ? 'italic' : 'normal'"
    [class.overridden]="internalIsOverridden"
    [(ngModel)]="internalValueFormatted"
    (ngModelChange)="onValueChange($event)"
    (blur)="onBlur()"
    [attr.data-sd-assessment-component-name]="componentName"/>
